export var D2CDiscountCategory;
(function (D2CDiscountCategory) {
    D2CDiscountCategory["DISCOUNT_CODE"] = "DISCOUNT_CODE";
    D2CDiscountCategory["USER_DISCOUNT"] = "USER_DISCOUNT";
    D2CDiscountCategory["SURE_DISCOUNT"] = "SURE_DISCOUNT";
})(D2CDiscountCategory || (D2CDiscountCategory = {}));
